import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar } from "@gemini/ui";
import { BuildingFilledIcon, UserFilledIcon } from "@gemini/icons";
import { Box } from "@gemini/core";
const renderIcon = (isPhysicalPerson, logoUrl) => {
    if (logoUrl) {
        return null;
    }
    const IconComponent = isPhysicalPerson ? UserFilledIcon : BuildingFilledIcon;
    return _jsx(IconComponent, { color: "color.content.onBrand.disabled" });
};
export const ContactLogo = ({ isPhysicalPerson, logoUrl, label = "", testId, href, }) => {
    const avatar = (_jsx(Avatar, { testId: testId, icon: () => renderIcon(!!isPhysicalPerson, logoUrl), imageUrl: logoUrl, label: label, size: "64", type: isPhysicalPerson ? "circle" : "square", imageFit: isPhysicalPerson ? "cover" : "contain" }));
    if (href) {
        return (_jsx(Box, { as: "a", href: href, "aria-label": label, target: "_blank", rel: "noopener noreferer", children: avatar }));
    }
    return avatar;
};
